import * as React from 'react';

const LondonGreenQuarterLogo = ({
  width = 75,
  height = 75,
  alt = 'Greenquarter'
}: React.ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      width={width}
      height={height}
      src="/static/assets/london-greenquarter.svg"
      alt={alt}
    />
  );
};

export default LondonGreenQuarterLogo;
